export const apiPrefix = 'https://node.deso.org/api/v0/'

export async function getAppState() {

    const url = `${apiPrefix}get-app-state`

    const data = {}
  
    const params = {
        method:'POST',
        body:JSON.stringify(data),
        headers: { 'Content-Type': 'application/json'}
    }
  
    try {
        const res = await fetch(url, params)
        const result = await res.json()   

        return {...result}        
    } catch (error) {
        return {...error} 
    }


}

export async function getDesoPrice() {

    const url = `https://api.coinbase.com/v2/prices/DESO-USD/spot`
  
    try {
        const res = await fetch(url)
        const result = await res.json()   

        return {...result}        
    } catch (error) {
        return {...error} 
    }


}

export async function getUserData(settings) {

    let {
        PublicKeysBase58Check // array of public keys
    } = settings

    const data = {
        "PublicKeysBase58Check": PublicKeysBase58Check,
        "SkipForLeaderboard": false      
    }    

    const url = `${apiPrefix}get-users-stateless`
  
    const params = {
        method:'POST',
        body:JSON.stringify(data),
        headers: { 'Content-Type': 'application/json'}
    }
  
    try {
        const res = await fetch(url, params)
        const result = await res.json()   

        return {...result}        
    } catch (error) {
        return {...error} 
    }


}

export async function submitPost(settings) {

    let {
            UpdaterPublicKeyBase58Check, 
            ParentStakeID = '', 
            RepostedPostHashHex = '',
            PostHashHexToModify = '',
            Body = '', 
            ImageURLs = null,
            VideoURLs = null,
            PostExtraData = null,
            MinFeeRateNanosPerKB
        } = settings

    const data = {
        "UpdaterPublicKeyBase58Check": UpdaterPublicKeyBase58Check,
        "PostHashHexToModify": PostHashHexToModify,
        "ParentStakeID": ParentStakeID,
        "Title": "",
        "BodyObj": {
            "Body": Body,
            "ImageURLs": ImageURLs,
            "VideoURLs": VideoURLs
        },
        "RepostedPostHashHex": RepostedPostHashHex,
        "PostExtraData": PostExtraData,
        "Sub": "",
        "IsHidden": false,
        "MinFeeRateNanosPerKB": MinFeeRateNanosPerKB,
        "InTutorial": false           
    }
  
    const url = `${apiPrefix}submit-post`
  
    const params = {
        method:'POST',
        body:JSON.stringify(data),
        headers: { 'Content-Type': 'application/json'}
    }
  
    try {
        const res = await fetch(url, params)
        const result = await res.json()   
        return {...result}        
    } catch (error) {
        return {...error} 
    }


}

export async function transferCreatorCoin(settings) {

    let {
            CreatorCoinToTransferNanos,
            CreatorPublicKeyBase58Check,
            ReceiverUsernameOrPublicKeyBase58Check,
            SenderPublicKeyBase58Check,
            MinFeeRateNanosPerKB
        } = settings

    const data = {
        "CreatorCoinToTransferNanos": CreatorCoinToTransferNanos,
        "CreatorPublicKeyBase58Check": CreatorPublicKeyBase58Check,
        "ReceiverUsernameOrPublicKeyBase58Check": ReceiverUsernameOrPublicKeyBase58Check,
        "SenderPublicKeyBase58Check": SenderPublicKeyBase58Check,
        "MinFeeRateNanosPerKB": MinFeeRateNanosPerKB  
    }
  
    const url = `${apiPrefix}transfer-creator-coin`
  
    const params = {
        method:'POST',
        body:JSON.stringify(data),
        headers: { 'Content-Type': 'application/json'}
    }

    console.log("params: ", params)
  
    try {
        const res = await fetch(url, params)
        const result = await res.json()   
        return {...result}        
    } catch (error) {
        return {...error} 
    }


}

export async function submitTransaction(settings) {

    let { signedTx } = settings

    const data = {
        TransactionHex: signedTx         
    }
  
    const url = `${apiPrefix}submit-transaction`
  
    const params = {
        method:'POST',
        body:JSON.stringify(data),
        headers: { 'Content-Type': 'application/json'}
    }
  
    try {
        const res = await fetch(url, params)
        const result = await res.json()   
        return {...result}        
    } catch (error) {
        return {...error} 
    }


}

